// src/pages/AgreementPage.tsx
import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Button from "../components/Button";
import "./AgreementPage.css";
import { useAgreementsQuery, useAgreementMutation } from "../store/api/authApi";

const AgreementPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { data: agreementData } = useAgreementsQuery();
    const [agreement] = useAgreementMutation();

    // Начальное состояние зависит от того, принято ли соглашение ранее в базе
    const [agreed, setAgreed] = useState(false);

    useEffect(() => {
        if (agreementData?.result === true) {
            setAgreed(true);
        }
    }, [agreementData?.result]);

    const handleAgree = async () => {
        // ⚠️ Если чекбокс НЕ отмечен — подтверждаем отзыв согласия
        if (!agreed) {
            const confirmWithdraw = window.confirm(
                "Вы уверены, что хотите отозвать согласие? Доступ к приложению будет заблокирован."
            );

            if (confirmWithdraw) {
                try {
                    await agreement({ agree: 0 }).unwrap(); // Передаем 0 или false в зависимости от вашей ручки
                    localStorage.removeItem("user_agreement");
                    // Перенаправляем на страницу блокировки на вебе
                    navigate("/agreement-wall");
                } catch (e) {
                    alert("Не удалось сохранить изменения. Попробуйте снова.");
                }
            }
            return;
        }

        // ✅ Если чекбокс ОТМЕЧЕН — принимаем соглашение
        try {
            await agreement({ agree: 1 }).unwrap();
            localStorage.setItem("user_agreement", "true");

            const isReg = searchParams.get("reg");
            if (isReg) {
                // Если пришли с регистрации, ведем на следующий шаг (или согласие на переупаковку)
                navigate(`/repack-consent?${searchParams.toString()}`);
            } else {
                navigate("/personal-info");
            }
        } catch (e) {
            alert("Не удалось сохранить соглашение. Попробуйте снова.");
        }
    };

    return (
        <div className="agreement-container" style={{ padding: "20px 10px", display: "flex", justifyContent: "center" }}>
            <div
                className="agreement-content"
                style={{
                    maxWidth: "900px",
                    width: "100%",
                    backgroundColor: "#fff",
                    padding: "24px",
                    borderRadius: "16px",
                    boxShadow: "0 6px 30px rgba(16,61,100,0.06)",
                    color: "#000",
                    lineHeight: "1.6",
                    fontFamily: "Arial, sans-serif"
                }}
            >
                <h1 style={{ fontSize: "26px", fontWeight: "700", color: "#103d64", marginBottom: "10px" }}>
                    Пользовательское соглашение
                </h1>

                <div style={{ width: "120px", height: "2px", backgroundColor: "#103d64", marginBottom: "20px" }} />

                <p style={{ fontSize: "16px", marginBottom: "14px" }}>
                    Настоящее Пользовательское соглашение (далее – «Соглашение») является
                    юридически обязывающим договором между ОсОО «Онза» (ИНН 00108202310490),
                    осуществляющим деятельность под фирменным наименованием «Onza.kg»
                    (далее – «Onza.kg», «Исполнитель»), и Вами, физическим лицом,
                    являющимся пользователем сайта или мобильного приложения Onza.kg
                    (далее – «Пользователь»).
                </p>

                <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#103d64", marginTop: "16px", marginBottom: "6px" }}>
                    1. Международная перевозка посылок
                </h3>
                <p style={{ fontSize: "16px", marginBottom: "14px" }}>
                    Onza.kg обязуется предоставлять Пользователю услуги по
                    международной перевозке посылок, заказанных Пользователем на
                    зарубежных сайтах, с зарубежных складов Onza.kg до территории
                    Кыргызской Республики, а именно до пунктов, указанных в разделе
                    «Контакты» Сайта/Приложения Onza.kg, либо до указанной
                    Пользователем точки доставки в г. Бишкек.
                </p>

                <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#103d64", marginTop: "16px", marginBottom: "6px" }}>
                    2. Права и обязанности Пользователя
                </h3>
                <p style={{ fontSize: "16px", marginBottom: "14px" }}>
                    Пользователь вправе по всем вопросам обращаться к Исполнителю
                    посредством WhatsApp на номер горячей линии +996 227 080 008
                    (далее – «Горячая линия»).
                </p>
                <p style={{ fontSize: "16px", marginBottom: "14px" }}>Пользователь обязуется:</p>
                <ul style={{ marginLeft: "20px", marginBottom: "14px", listStyleType: "none", padding: 0 }}>
                    <li style={{ fontSize: "16px", marginBottom: "4px" }}>
                        a) ознакомиться полностью с разделами «Тарифы» и «Вопросы и ответы» на сайте/Приложении Onza.kg;
                    </li>
                    <li style={{ fontSize: "16px", marginBottom: "4px" }}>
                        b) корректно указывать адреса зарубежных складов Onza.kg;
                    </li>
                    <li style={{ fontSize: "16px", marginBottom: "4px" }}>
                        c) незамедлительно сообщить на Горячую линию о проблемах с трек-номером посылки;
                    </li>
                    <li style={{ fontSize: "16px", marginBottom: "4px" }}>
                        d) оплачивать услуги международной перевозки согласно тарифам.
                    </li>
                </ul>

                <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#103d64", marginTop: "16px", marginBottom: "6px" }}>
                    3. Персональные данные и конфиденциальность
                </h3>
                <p style={{ fontSize: "16px", marginBottom: "14px" }}>
                    Персональная информация является конфиденциальной и используется
                    исключительно для выполнения требований таможенного
                    законодательства Кыргызской Республики.
                </p>

                <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#103d64", marginTop: "16px", marginBottom: "6px" }}>
                    4. Достоверность данных
                </h3>
                <p style={{ fontSize: "16px", marginBottom: "14px" }}>
                    Пользователь обязуется предоставлять достоверные и актуальные
                    сведения при регистрации и использовании Сайта/Приложения.
                </p>

                <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#103d64", marginTop: "16px", marginBottom: "6px" }}>
                    5. Сохранность товара и состояние упаковки
                </h3>
                <ul style={{ marginLeft: "20px", marginBottom: "14px", listStyleType: "none", padding: 0 }}>
                    <li style={{ fontSize: "16px", marginBottom: "6px" }}>
                        1. Исполнитель обязуется обеспечить сохранность Товара в
                        процессе хранения, погрузочно-разгрузочных работ и
                        транспортировки до момента передачи Получателю.
                    </li>
                    <li style={{ fontSize: "16px", marginBottom: "6px" }}>
                        2. Стороны согласовали, что предметом ответственности
                        Исполнителя является сохранность самого Товара, его количество,
                        комплектность и потребительские свойства.
                    </li>
                    <li style={{ fontSize: "16px", marginBottom: "6px" }}>
                        3. Учитывая особенности перевозки и логистической обработки
                        грузов, допускается наличие незначительных механических
                        повреждений внешней упаковки (в том числе замятие, деформация
                        или потертости картона, преимущественно по углам и краям
                        упаковки), возникших в ходе обычной перевозки, при условии, что
                        такие повреждения не повлекли нарушение целостности Товара, его
                        утрату, повреждение, ухудшение качества, комплектности или
                        потребительских свойств.
                    </li>
                    <li style={{ fontSize: "16px", marginBottom: "6px" }}>
                        4. Незначительные повреждения внешней транспортной упаковки, не
                        влияющие на сохранность Товара, не являются основанием для
                        предъявления претензий к Исполнителю, отказа от приемки Товара,
                        требования о замене Товара либо возмещения убытков.
                    </li>
                    <li style={{ fontSize: "16px", marginBottom: "6px" }}>
                        5. В случае выявления повреждений Товара, вызванных ненадлежащим
                        исполнением Исполнителем своих обязательств, Исполнитель несет
                        ответственность в соответствии с условиями настоящего Договора и
                        применимым законодательством.
                    </li>
                </ul>

                <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#103d64", marginTop: "16px", marginBottom: "6px" }}>
                    6. Принятие условий Соглашения
                </h3>
                <p style={{ fontSize: "16px", marginBottom: "14px" }}>
                    Нажимая кнопку «Принять», Пользователь подтверждает полное
                    ознакомление и согласие с условиями Соглашения.
                </p>

                {/* Удаление персональных данных (Из старого веб-кода, если нужно оставить) */}
                <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#103d64", marginTop: "16px", marginBottom: "6px" }}>
                    7. Удаление персональных данных
                </h3>
                <p style={{ fontSize: "16px", marginBottom: "14px" }}>
                    Пользователь имеет право в любое время запросить удаление своих персональных данных. Для этого необходимо обратиться к менеджеру через мессенджер WhatsApp по официальному номеру. Данные будут удалены в течение 24 часов.
                </p>

                {/* Чекбокс */}
                <div style={{ display: "flex", alignItems: "flex-start", marginTop: "20px" }}>
                    <input
                        type="checkbox"
                        checked={agreed}
                        onChange={(e) => setAgreed(e.target.checked)}
                        style={{ marginTop: "4px", cursor: "pointer" }}
                    />
                    <span style={{ flex: 1, fontSize: "14px", lineHeight: "20px", marginLeft: "10px" }}>
                        Я ознакомился и принимаю условия Пользовательского соглашения и
                        согласен на обработку моих персональных данных.
                    </span>
                </div>

                {/* Кнопка — меняет цвет и текст динамически */}
                <Button
                    onClick={handleAgree}
                    style={{
                        backgroundColor: agreed ? "#103d64" : "#c0392b",
                        color: "white",
                        width: "100%",
                        marginTop: 20,
                        paddingVertical: "14px",
                        transition: "background-color 0.2s ease",
                    }}
                >
                    {agreed ? "Принять" : "Отозвать согласие"}
                </Button>
            </div>
        </div>
    );
};

export default AgreementPage;